export const EndOngoingSessionModalStates = {
	open: false,
	message: "",
	isOverMaxMessageLength: false,
	isLoading: false,
	isError: false,
	errorMessage: ""
}

export const CONST_MAX_MESSAGE_LENGTH = 100
